import React, { useCallback, useEffect } from 'react';
import styled from 'styled-components';
// import { DEVICE_SIZE, mq } from '@marty-js/design/src/utils/mq';
import { HeadingTwo } from '@marty-js/design/src/atoms/h2';
import { useTranslation } from '@marty-js/design/src/utils/translation';
import { useImageComponent } from '@marty-js/design/src/utils/component';
import { useAddImage, useViewerContext } from '../article-processor/viewer-context';

type MediaImageDetails = {
  height?: number;
  width?: number;
  name?: string;
  copyright?: string;
  id?: number;
  url?: string;
};

type MediaImage = {
  src: string;
  order?: number;
  main?: boolean;
  details?: MediaImageDetails;
};

type Props = {
  screenshots: MediaImage[];
};

const Screenshots = styled.div`
  display: flex;
  flex-direction: row;
  gap: var(--spacer-m);
  margin-bottom: var(--spacer-m);
  margin-top: var(--spacer-s);
  flex-wrap: wrap;
`;

const Screenshot = styled.div`
  cursor: pointer;
  transition: scale ease-in-out 0.2s;

  :hover {
    scale: 1.1;
  }
`;

export const SoftwareScreenshots = ({ screenshots }: Props) => {
  const ImageComponent = useImageComponent();
  const t = useTranslation();
  const { setShowModal, setCurrentImageId } = useViewerContext();
  const addImage = useAddImage();

  useEffect(() => {
    screenshots.forEach((mediaImage) => {
      const image = {
        width: mediaImage.details.width,
        height: mediaImage.details.height,
        id: mediaImage.src,
      };

      addImage(image);
    });
  }, [screenshots, addImage]);

  const showImage = useCallback(
    (mediaImageId) => {
      setCurrentImageId(mediaImageId);
      setShowModal(true);
    },
    [setShowModal, setCurrentImageId],
  );

  return (
    <>
      <HeadingTwo>{t('design.download.screenshots')}</HeadingTwo>
      <Screenshots>
        {screenshots.map((mediaImage) => {
          const imageProps = {
            imageId: mediaImage.src,
            alt: mediaImage?.details?.name || t('design.download.screenshot'),
            desktopWidth: 140,
            desktopHeight: 140,
            mobileWidth: 140,
            mobileHeight: 140,
          };

          const key = `screenshot_${mediaImage.src}`;

          return (
            <Screenshot
              key={key}
              onClick={() => {
                showImage(mediaImage.src);
              }}
            >
              <ImageComponent {...imageProps} />
            </Screenshot>
          );
        })}
      </Screenshots>
    </>
  );
};
